export type NamedCompetitor = {
  id: string;
  name: string;
  address?: string;
};

/** First address part, usually street and number ("Alexanderplatz 1"). */
function addressHint(address: string | undefined): string | null {
  const first = address?.split(',')[0]?.trim();
  return first ? first : null;
}

/**
 * Display names by competitor id: branches that share a name get their
 * street, e.g. "Einstein Kaffee · Alexanderplatz 1" (DEV-822).
 */
export function competitorDisplayNames(
  competitors: readonly NamedCompetitor[],
): Map<string, string> {
  const counts = new Map<string, number>();
  for (const competitor of competitors) {
    const key = competitor.name.trim().toLocaleLowerCase();
    counts.set(key, (counts.get(key) ?? 0) + 1);
  }
  const names = new Map<string, string>();
  for (const competitor of competitors) {
    const key = competitor.name.trim().toLocaleLowerCase();
    const hint = addressHint(competitor.address);
    names.set(
      competitor.id,
      (counts.get(key) ?? 0) > 1 && hint
        ? `${competitor.name} · ${hint}`
        : competitor.name,
    );
  }
  return names;
}
